<template>
  <div class="LmInput relative mb-8">
    <label
      class="block mb-1 font-mono text-xxs uppercase tracking-wider text-gray-500"
      >Related actors (optional)</label
    >
    <v-select
      v-model="value"
      class="LmActorSelector"
      :options="options"
      max-height="280px"
      :close-on-select="false"
      multiple
    >
      <template slot="selected-option" slot-scope="option">
        <span class="font-mono text-xs" :class="cc(option.color)">{{
          option.label
        }}</span>
      </template>
      <template slot="option" slot-scope="option">
        <span class="font-mono text-xs" :class="cc(option.color)">{{
          option.label
        }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'LmActorSelector',
  components: {vSelect},
  props: {
    actors: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      value: []
    }
  },
  computed: {
    ...mapGetters(['getActors', 'currentTopic', 'selectedActorID']),
    data() {
      return this.value.map(tag => tag.id)
    },
    options() {
      const topicActor = this.currentTopic
        ? this.currentTopic.actorId
        : this.selectedActorID
      return Object.keys(this.getActors)
        .filter(id => topicActor !== id)
        .map(id => this.parseActor(id))
    }
  },
  watch: {
    actors() {
      if (this.actors) {
        this.value = this.actors.map(this.parseActor).filter(actor => !!actor)
      }
    }
  },
  methods: {
    cc(color) {
      return `text-${color}`
    },
    parseActor(actorId) {
      const actor = this.getActors[actorId]
      if (actor) {
        return {
          id: actorId,
          label: actor.name,
          color: actor.color
        }
      }
    },
    validateData() {
      return true
    },
    reset() {
      this.value = []
    },
    clearErrors() {}
  }
}
</script>

<style>
.LmActorSelector {
  .vs__selected-options span.selected-tag {
    background-color: theme('colors.white') !important;
  }
  &.v-select ul.dropdown-menu .highlight a {
    background-color: theme('colors.gray.200') !important;
  }
}
</style>
